export function ConnectionLineShort(props) {
  const { className, stroke, ...rest } = props;
  return (
    <svg width='9' height='74' viewBox='0 0 9 74' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path d='M3.57628e-07 73H4C6.20914 73 8 71.2091 8 69L8 5.00001C8 2.79087 6.20914 1 4 1H3.57628e-07' stroke={stroke} />
    </svg>
  );
}
